import { DefaultService } from '@/services/DefaultService';

export default class AdiantamentoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    changeSituacao(id, situacao) {
        return this._http.get(`${this._env}/despesa/adiantamento/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/despesa/adiantamento/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(filtros, column, order, page, limit, ...params) {
        return this._http.post(encodeURI(`${this._env}/despesa/adiantamento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    //Busca adiantamento para serem listados na tela de acerto, com base no IDACERTO e IDUSUARIO
    findAllAdiantamentoByIdusuario(idusuario, idacerto) {
        return this._http.get(`${this._env}/despesa/adiantamento/listbyuser.json?idusuario=${idusuario}&idacerto=${idacerto}`, this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    save(form) {
        return this._http.post(`${this._env}/despesa/adiantamento`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deleteAdiantamentoById(id, motivo = "") {
        return this._http.delete(`${this._env}/despesa/adiantamento/${id}?motivo=${motivo}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}